import {Observable} from "rxjs";

export abstract class AppVersionNative {

    /**
     * Returns the version number of the native application (Android or iOS).
     * @returns An observable that emits the version number as a string like "1.0.0".
     *          If the version number cannot be retrieved (like on web), the observable emits an empty string.
     */
    public abstract getVersionNumber(): Observable<string> ;

}